import { createContext } from 'react';
import { FileStoreState } from '../types';

export const FileStoreContext = createContext<FileStoreState>({
    filesRef: { current: {} },
    setFiles: () => null,
});
